<ng-container *transloco="let t">
	<eventlyte-registration-stepper-progress
		[currentStep]="AppRoutePaths.RegistrationGroup"
		[steps]="getSteps()"
		[maxStepReached]="maxStepReached" />

	<p class="title is-4 pb-1 mb-1">{{ t('content.steps.group') }}</p>

	<div class="content">
		<p>{{ t('content.pages.registrationGroup.instructions') }}</p>
	</div>

	<eventlyte-primitive-tag-list-field
		[value]="totalRecords()"
		(valueChange)="updateTotalRecords($event)"
		[editing]="true"
		[label]="t('content.pages.registrationGroup.totalRecordsLabel')">
		<eventlyte-tag-field
			[value]="0"
			[label]="t('content.registrationGroup.totalRecordsIndexedPlural', { count: 0 })"
			[background]="ViewColor.Light" />
		<eventlyte-tag-field
			[value]="1"
			[label]="t('content.registrationGroup.totalRecordsIndexedSingular', { count: 1 })"
			[background]="ViewColor.Light" />
		<eventlyte-tag-field
			[value]="2"
			[label]="t('content.registrationGroup.totalRecordsIndexedPlural', { count: 2 })"
			[background]="ViewColor.Light" />
		<eventlyte-tag-field
			[value]="3"
			[label]="t('content.registrationGroup.totalRecordsIndexedPlural', { count: 3 })"
			[background]="ViewColor.Light" />
		<eventlyte-tag-field
			[value]="4"
			[label]="t('content.registrationGroup.totalRecordsIndexedPlural', { count: 4 })"
			[background]="ViewColor.Light" />
		<eventlyte-tag-field
			[value]="5"
			[label]="t('content.registrationGroup.totalRecordsIndexedPlural', { count: 5 })"
			[background]="ViewColor.Light" />
	</eventlyte-primitive-tag-list-field>

	<hr />

	@if (totalRecords() > 0) {
		<app-registration-group-page-record
			[(record)]="extraRecords()[0]"
			[formGroup]="formGroups[0]"
			[recordIndex]="1" />
	}

	@if (totalRecords() > 1) {
		<app-registration-group-page-record
			[(record)]="extraRecords()[1]"
			[formGroup]="formGroups[1]"
			[recordIndex]="2" />
	}

	@if (totalRecords() > 2) {
		<app-registration-group-page-record
			[(record)]="extraRecords()[2]"
			[formGroup]="formGroups[2]"
			[recordIndex]="3" />
	}

	@if (totalRecords() > 3) {
		<app-registration-group-page-record
			[(record)]="extraRecords()[3]"
			[formGroup]="formGroups[3]"
			[recordIndex]="4" />
	}

	@if (totalRecords() > 4) {
		<app-registration-group-page-record
			[(record)]="extraRecords()[4]"
			[formGroup]="formGroups[4]"
			[recordIndex]="5" />
	}

	<eventlyte-registration-stepper-controls
		[currentStep]="AppRoutePaths.RegistrationGroup"
		[steps]="getSteps()"
		(startAgain)="startAgain()"
		(submitClick)="continue()"
		[processing]="saving()"
		[isSubmit]="true" />

	@if (showFormErrors()) {
		<eventlyte-registration-form-errors-modal
			[(active)]="showFormErrors"
			[formGroups]="validationFormGroups!" />
	}

	@if (showServerErrors()) {
		<eventlyte-registration-server-errors-modal
			[(active)]="showServerErrors"
			[errorList]="serverErrorList()" />
	}
</ng-container>
